{
  "paymentMethod": {
    "BANK_CARD": "銀行卡",
    "ALIPAY": "支付寶",
    "WECHAT": "微信"
  },
  "flatFee": "單筆 {{amount}}",
  "vipConditionsTitle": "VIP {{level}} 極速交易條件",
  "noVipPaymentMethods": "目前VIP等級暫無可用極速交易支付方式",
  "fee": "手續費 {{value}}",
  "availableRange": "可用範圍 {{value}}",
  "checkout": "{{method}}支付",
  "close": "關閉",
  "checkoutLoading": "正在載入付款頁面…",
  "checkoutLoadFailed": "付款頁面暫時無法載入，請重試。",
  "retry": "重試",
  "checkoutHint": "請在此頁面完成{{method}}支付，完成後會自動確認到帳。",
  "openCheckout": "開啟付款頁面",
  "externalCheckoutHint": "請開啟新視窗完成{{method}}支付，完成後會自動確認到帳。您可以返回此處再次開啟付款頁面或選擇其他方式。",
  "externalCheckoutUnavailableHint": "如果付款頁面無法開啟或載入，請返回此處選擇其他付款方式。",
  "chooseOtherMethod": "選擇其他付款方式",
  "chooseOtherMethodHint": "僅在尚未付款時選擇其他方式。此訂單會保留至到帳或到期。"
}
